import { Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as styles from './KpiTiles.css';

export interface ITileErrorProps {
  label: string;
}

/**
 * Shared error layout for KPI tiles — renders the tile label above a generic
 * "couldn't load data" message so each tile fails independently with a consistent look.
 */
function TileError({ label }: Readonly<ITileErrorProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <Stack gap={theme.spacing['2']}>
      <span className={styles.label}>{label}</span>
      <span className={styles.errorText}>{t("Couldn't load data. Try refreshing.")}</span>
    </Stack>
  );
}

export default TileError;
